const stage = () => {
  const url = window.location.hostname;
  switch (url) {
    case "production-url":
      return "production";
    case "fa-station-admin-staging.web.app":
    case "fa-station-admin-staging.firebaseapp.com":
      return "uat";
    case "fa-station-admin-dev.web.app":
    case "fa-station-admin-dev.firebaseapp.com":
    case "localhost":
      return "dev";
    default:
      return null;
  }
};

let token = localStorage.getItem("token");

//   const baseUrl = () => {
//     // switch (stage()) {
//     //   case "production":
//     //     return "https://api.fastation.co.th/prod";
//     //   case "uat":
//     //     return "https://api.fastation.co.th/uat";
//     //   case "dev":
//     //     return "https://api.fastation.co.th/dev";
//     //   case "local":
//     //     return "http://localhost:3000/";
//     //   default:
//         return "https://api.fastation.co.th/dev";
//     // }
//   };

exports.baseurl = () => {
  return "https://api-elearning.houseofdev.tech/dev";
  // return "http://5b71-58-136-0-63.ngrok.io"
};

// export default baseUrl();
